import { createAction } from 'redux-actions'
import * as constants from './constants'

export const patchUserProperties = createAction(constants.PATCH_USER_PROPERTIES)
export const patchUserPropertiesPending = createAction(constants.PATCH_USER_PROPERTIES_PENDING)
export const patchUserPropertiesSuccess = createAction(constants.PATCH_USER_PROPERTIES_SUCCESS)
export const patchUserPropertiesFailed = createAction(constants.PATCH_USER_PROPERTIES_FAILED)
